export const propertyLicenceEventsQuery = `
  query PropertyLicenceEventsQuery (
    $search: String
    $propertyLicence: ID!
    $from: DatetimeTzInputType
    $to: DatetimeTzInputType
    $tournament: [ID]
    $contentCategoryLevel3: [ID]
    $eventStatus: [ID]
    $product: [ID]
    $reportType: [ID]
    $incidentType: [ID]
    $incidentSource: [ID]
  ) {
    propertyLicenceEvents (
      propertyLicence: $propertyLicence
      filters: {
        search: $search
        from: $from
        to: $to
        tournament: $tournament
        contentCategoryLevel3: $contentCategoryLevel3
        eventStatus: $eventStatus
        product: $product
        reportType: $reportType
        incidentType: $incidentType
        incidentSource: $incidentSource
  	  }
    ) {
      id
      start_datetime
      end_datetime
      duration
      description
      external_description
      color
      event_type {
        id
        name
      }
      property_licence_type {
        id
        name
      }
      reports {
        id
        includes_all_streams
        count_as_downtime
        comment
        incident_duration
        report_scopes_view {
          text
          event_content_variant {
            id
            name
            short_name
          }
        }
        report_type {
          id
          name
        }
        incident_source {
          id
          name
        }
        incident_type {
          id
          name
        }
        incident_duration_unit {
          id
          short_name
        }
        report_scopes {
          event_content_id
          event_content_name
          event_content_type { id name }
          event_content_variant { id name short_name }
          distribution_id
          product { id name short_name }
          distribution_type { id name }
          stream_variants { id name short_name }
        }
      }
      event_status {
        id
        name
      }
      products_invoice_status {
        product_id: id
        name
        short_name
        has_usage
        invoice_status {
          id
          name
        }
      }
      bookings
      is_unreportable
      has_no_coverage
      has_partial_coverage
      has_full_coverage
      sr_event {
        id
        tournament {
          id
          name
          tournament_category {
            id
            name
          }
        }
        home_competitor {
          id
          name
        }
        away_competitor {
          id
          name
        }
        match {
          id
          start_datetime
          started_datetime
          ended_datetime
          tournament {
            id
            name
            tournament_category {
              id
              name
            }
          }
          home_competitor {
            id
            name
          }
          away_competitor {
            id
            name
          }
        }
      }
      av_event {
        id
        content_category_level2 {
          id
          name
        }
        content_category_level3 {
          id
          name
        }
        home_av_competitor {
          id
          name
        }
        away_av_competitor {
          id
          name
        }
      }
      event_contents {
        id
        name
        is_main_content
        event_content_type {
          id
          name
        }
        event_content_variant {
          id
          name
          short_name
        }
        products {
          product_id
          short_name
          distributions {
            id
            distribution_type { id name }
            product_status { id name }
            targets
            bookings
            invoice_status { id name }
          }
        }
      }
    }
  }
`;

export const propertyLicenceEventsFiltersQuery = `
  query PropertyLicenceEventsFiltersQuery (
    $propertyLicence: ID!
  ) {
    propertyLicenceContents (filters: {
      propertyLicence: $propertyLicence
    }) {
      tournament {
        id
        name
        tournament_category {
          id
          name
        }
      }
      content_category {
        id
        name
        parent {
          id
          name
        }
      }
    }
    eventStatuses {
      key: id
      text: name
      value: id
    }
    products {
      key: id
      text: short_name
      value: id
    }
    reportTypes {
      key: id
      text: name
      value: id
    }
    incidentSources {
      key: id
      text: name
      value: id
    }
    incidentTypes {
      key: id
      text: name
      value: id
    }
  }
`;
